import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import AiAssistantChat from "./AiAssistantChat";

export default function AiAssistantWidget({ mobile = false }) {
  const [open, setOpen] = useState(false);
  const btnPos = mobile ? "right-4 bottom-[calc(84px+env(safe-area-inset-bottom))]" : "right-6 bottom-6";
  return (
    <>
      {!open && (
        <button onClick={() => setOpen(true)} className={`fixed ${btnPos} z-40 h-12 pl-3.5 pr-4 rounded-full bg-slate-900 text-white shadow-xl shadow-slate-900/25 flex items-center gap-2 hover:scale-[1.03] active:scale-95 transition-transform`} data-testid="ai-assistant-open">
          <span className="relative flex"><Sparkles className="w-5 h-5 text-amber-300" /><span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-amber-300 animate-pulse" /></span>
          <span className="font-barlow font-bold text-[14px] tracking-wide">Yapay Zeka</span>
        </button>
      )}
      {open && (
        <div className={mobile ? "fixed inset-0 z-50 flex flex-col bg-white" : "fixed right-6 bottom-6 z-50 w-[400px] max-w-[calc(100vw-2rem)] h-[600px] max-h-[calc(100vh-3rem)] flex flex-col bg-white rounded-2xl shadow-2xl shadow-slate-900/30 border border-slate-200 overflow-hidden"} data-testid="ai-assistant-panel">
          <div className="flex items-center justify-between gap-3 px-4 bg-slate-900 text-white shrink-0" style={mobile ? { paddingTop: "calc(12px + env(safe-area-inset-top))", paddingBottom: 12 } : { paddingTop: 12, paddingBottom: 12 }}>
            <div className="flex items-center gap-2.5 min-w-0">
              <span className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center shrink-0"><Sparkles className="w-4.5 h-4.5 text-amber-300" /></span>
              <div className="min-w-0">
                <p className="font-barlow font-bold text-[15px] leading-tight">Yapay Zeka Asistan</p>
                <p className="text-[11px] text-slate-300 truncate">Fiyat · Taksit · Kampanya</p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="w-9 h-9 rounded-full hover:bg-white/10 flex items-center justify-center shrink-0" data-testid="ai-assistant-close"><X className="w-5 h-5" /></button>
          </div>
          <div className="flex-1 min-h-0" style={mobile ? { paddingBottom: "env(safe-area-inset-bottom)" } : undefined}>
            <AiAssistantChat compact={!mobile} />
          </div>
        </div>
      )}
    </>
  );
}
